import * as Yup from 'yup';

const updatePaymentMethod = Yup.object().shape({
  paymentMethod: Yup.string()
    .required('Payment method is required')
    .oneOf(
      ['card', 'invoice', 'exempt'],
      'Payment method must be either card or invoice or exempt'
    )
});

export default updatePaymentMethod;
